
<div class="content-section">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
  <div class="title-div">
    <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
        <div class="col-11 p-0">
          <a class="back_bd" (click)="backToManageTutorials()">
            <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a
          >
          <h2 class="background_title">{{ "E_LEARNING.TUTORIALS" | translate }}</h2>
        </div>
    </div>
  </div>
  <div class="container-fluid alone ">
    <div
    class="alert alert-warning"
    role="alert"
    *ngIf="tutorialDetails && tutorialDetails.length == 0"
  >
    {{ translationKeys.Dashboard.NoDataFound | translate }}
  </div>
    <div class="container-cards">

       <div
        class="card_bd"
        *ngFor="let tutorialDetail of tutorialDetails; let i = index"
        (click)="
          openModal(
            template,
            tutorialDetail.fileURL,
            tutorialDetail.type,
            tutorialDetail.title
          )
        "
      >
        <div>
            <div class="p-0 card_media_bd">
              <div class="card_media_bd_top">
                <img
                class="mx-auto d-block"
                  *ngIf="tutorialDetail.type == 'pdf'"
                  src="assets/ph-bhp-elearning/svg/icon-tutorial.svg"
                />
                <img
                class="mx-auto d-block"
                  *ngIf="tutorialDetail.type == 'video'"
                  src="assets/ph-bhp-elearning/svg/img1.jpg"
                />
                <img
                  *ngIf="tutorialDetail.type == 'video'"
                  class="video-icon mx-auto d-block"
                  src="assets/ph-bhp-configuration/svg/icon-play-video.svg"
                />
              </div>
              <div class="card_content_bd ">
                <div class="row">
                  <div class="col-12 card-title">
                    {{ tutorialDetail.title | labelSanitizer }}
                  </div>
                  <div class="col-12 card-subtitle">
                    {{ tutorialDetail.description | labelSanitizer }}
                  </div>
                </div>

              </div>
            </div>


        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #template>
  <div *ngIf="filetype == 'video'" class="heightFull">
    <video
      *ngIf="filetype == 'video'"
      width="100%"
      height="100%"
      [src]="fileurl | safe"
      controlsList="nodownload"
      autoplay
      controls
    ></video>
  </div>

  <div *ngIf="filetype == 'pdf'" class="heightFull">
    <div class="modal-body">
      <div class="content-inner">
        <div class="container-fluid p-0 col-11">
          <div class="d-flex justify-content-end">
            <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"
              ><img src="assets/ph-bhp-layout/svg/remove.svg"
            /></a>
          </div>

          <h2 class="page-title">{{ filetitle }}</h2>
        </div>
        <div class="embed-container">
          <embed
            *ngIf="filetype == 'pdf'"
            [src]="fileurl | safe"
            width="100%"
            height="700px"
            type="application/pdf"
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>
